export default __webpack_public_path__ + "img/chZEsCda.cfae04ec.svg";